import { Component, ViewChild, ViewContainerRef} from '@angular/core';
import { AppSettings } from './app.settings';
import { Settings } from './app.settings.model';
import { TranslateService } from '@ngx-translate/core';
import { LicenseHub } from './shared/services/signalR/licenseHub.service';
import { JoyrideService } from 'ngx-joyride';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  public settings: Settings;
  constructor(public appSettings:AppSettings,public translate: TranslateService, private licenseHub : LicenseHub, public vcRef: ViewContainerRef){
      this.settings = this.appSettings.settings;
      translate.setDefaultLang('de');
      licenseHub.startConnection();
      licenseHub.receiveLicense();

  } 
  switchLanguage(language: string) {
    this.translate.use(language);
  }
  ngOnInit() { }

}